var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "Carousel",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Carousel.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-716830c7!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./Carousel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/carousel/Carousel.vue
// module id = 96
// module chunks = 0